import React from 'react';

import classNames from 'classnames';
import PropTypes from 'prop-types';
import ReactHeadroom from 'react-headroom';

import styles from './ShowHideOnScroll.scss';

function ShowHideOnScroll(props) {
    const {
        className = '',
        children,
        ...otherProps
    } = props;

    return (
        <ReactHeadroom
            className={classNames(className, styles.container)}
            {...otherProps}
        >
            {children}
        </ReactHeadroom>
    );
}

ShowHideOnScroll.propTypes = {
    children: PropTypes.node.isRequired,
    className: PropTypes.string,
};

export default ShowHideOnScroll;
